// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"6d2149554e17326185f2","293":"4a603828d358a99d41e7","518":"6f54279fba6f18c3c04e","779":"c392e46601a8923f4ed4"}[chunkId] + ".js";
};